// extracted by mini-css-extract-plugin
module.exports = {"container":"LegendeSurvol_container__4M3al"};